import React from 'react';
import { TubeRow, SpacerBox, PlatedSpacerBox, FillElement, StaticFill, SpacerRingCombo } from './primitives';

export const FeedingStation = ({ spacers, scale, alignmentWidth, spacerAllocation, topFillRight, bottomFillRight, topFillRightWidth, bottomFillRightWidth, topLeftPad, bottomLeftPad, title }) => (
  <div className="bg-zinc-800 rounded-lg p-2 sm:p-3 border border-zinc-700 print:bg-gradient-to-br print:from-purple-50 print:to-violet-50 print:border-purple-200" style={{ overflow: 'visible' }}>
    <h3 className="font-semibold text-purple-400 mb-1 sm:mb-2 flex items-center gap-1.5 text-xs sm:text-sm print:text-purple-900">
      <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" strokeWidth="2"/>
        <line x1="9" y1="3" x2="9" y2="21" strokeWidth="2"/>
        <line x1="15" y1="3" x2="15" y2="21" strokeWidth="2"/>
      </svg>
      {title || 'Feeding Station'}
    </h3>
    
    <div className="space-y-1 sm:space-y-2" style={{ overflow: 'visible' }}>
      {/* Top Station Tube - plated spacer */}
      <TubeRow>
        <StaticFill width={topLeftPad} />
        <PlatedSpacerBox width={alignmentWidth.top} value={spacers.feedingTop} colorClass="bg-gradient-to-br from-purple-400 to-purple-500 border-purple-600" scale={scale} />
        <FillElement width={topFillRightWidth} value={topFillRight} />
      </TubeRow>

      {/* Bottom Station */}
      <TubeRow>
        <StaticFill width={bottomLeftPad} />
        <SpacerBox width={alignmentWidth.bottom} value={spacers.feedingBottom} colorClass="bg-gradient-to-br from-violet-500 to-violet-600 border-violet-700" />
        <FillElement width={bottomFillRightWidth} value={bottomFillRight} />
      </TubeRow>
      {/* Spacer ring combination */}
      <div className="flex items-center gap-2 ml-1">
        <span className="text-[10px] text-zinc-400 print:text-gray-500">Rings:</span>
        <SpacerRingCombo groups={spacerAllocation || []} />
      </div>
    </div>
  </div>
);
